import Enum from "../../../enums/Enum";


const FormLanguages = new Enum({
    ENGLISH: {name: "English"},
    ARABIC: {name: "Arabic"}
});

export default FormLanguages;